export const removeServiceAddOn = (state, addOnId) => {
  state.serviceAddOns = state.serviceAddOns.filter(
    (addon) => addon.id !== addOnId
  )
}

export const removeServiceModifier = (state, modifierId) => {
  state.serviceModifiers = state.serviceModifiers.filter(
    (mod) => mod.id !== modifierId
  )
}

export const removeServiceTax = (state, taxId) => {
  state.serviceTaxes = state.serviceTaxes.filter((tax) => tax.id !== taxId)
}

export const removeService = (state, serviceId) => {
  state.services = state.services.filter((service) => service.id !== serviceId)
}

export const setCompany = (state, company) => {
  state.company = company
}

export const setCustomFields = (state, fields) => {
  state.customFields = fields
}

export const setExpandedServiceId = (state, serviceId) => {
  state.expandedServiceId = serviceId
}

export const setLoadingObjects = (state, payload) => {
  state[`loading${payload.object}`] = payload.value
}

export const setServiceCategories = (state, records) => {
  state.serviceCategories = records
}

export const setServiceClassifications = (state, records) => {
  state.serviceClassifications = records
}

export const setShowError = (state, value = true) => {
  state.showError = value
  if (!value) {
    // Clear errors
    state.errors = []
  }
}

export const setShowSaved = (state, value = true) => {
  state.showSaved = value
}

export const setUndeleteModal = (state, value = true) => {
  state.undeleteModal = value
}

export const setUserProfile = (state, item) => {
  state.userProfile = item
}

export const shiftError = (state) => {
  let errors = state.errors.slice()
  errors.shift()
  state.errors = errors
  if (errors.length < 1) {
    state.showError = false
  }
}

export const showError = (state, error) => {
  state.errors = [error].concat(state.errors)
  state.showError = true
}

export const updateAgreements = (state, agreements) => {
  state.agreements = agreements
}

export const updateCollectionRecord = (state, payload) => {
  let updatedItems = []

  state[payload.key].forEach((item) => {
    if (payload.record.id === item.id) {
      updatedItems.push(payload.record)
    } else {
      updatedItems.push(item)
    }
  })

  state[payload.key] = updatedItems
}

export const updateServiceAddOns = (state, addOns) => {
  state.serviceAddOns = addOns.sort((a, b) => {
    return a.attributes.priority - b.attributes.priority
  })
}

export const updateServiceModifiers = (state, modifiers) => {
  state.serviceModifiers = modifiers
}

export const updateServiceTaxes = (state, taxes) => {
  state.serviceTaxes = taxes.sort((a, b) => {
    return a.attributes.priority - b.attributes.priority
  })
}

export const updateServices = (state, services) => {
  state.services = services
}

export const updateTemplates = (state, templates) => {
  state.templates = templates
}

export const updateUndeletableServices = (state, services) => {
  state.undeletableServices = services
}
